import * as React from 'react';
import { observer } from 'mobx-react';

import { Checkbox } from 'office-ui-fabric-react';
import { IDisabledProps } from '@app/Models/IDisabledProps';
import { PersonInfoModel } from '@app/Models';
import { securityService } from '@app/Services/SecurityService';
import { Permissions } from '@app/AppConstants';
import { AzureAuth } from '@app/Components/AzureAuth';

type ChangeCheckboxCallback = (field: keyof PersonInfoModel, value: boolean) => void;

type IntranetBlockProps =  IDisabledProps & {
    personInfo: PersonInfoModel;
    onChangeCheckboxHandler: ChangeCheckboxCallback;
};

@observer
export class IntranetBlock extends React.Component<IntranetBlockProps, {}> {
    render() {
        const { personInfo } = this.props;
		if (!personInfo) return;

        const { hasPermission, permissionCss } = securityService;
        const hasAccessToNonReleasedCASchedule = hasPermission(Permissions.ViewCanSeeNonReleasedCASchedule);
        const hasAccessToNonReleasedCOSchedule = hasPermission(Permissions.ViewCanSeeNonReleasedCOSchedule);
        const hasAccessToDownloadBuddySchedules = hasPermission(Permissions.ViewCanDownloadBuddySchedules);
        const hasAccessToAllSchedules = hasPermission(Permissions.ViewCanSeeAllSchedules);

        if (!hasAccessToNonReleasedCASchedule && !hasAccessToNonReleasedCOSchedule && !hasAccessToDownloadBuddySchedules && !hasAccessToAllSchedules) {
            return null;
        }

        return (
            <div className="col-xl-6 col-md-12 col-sm-12 person-info-block">
                <fieldset className="person-info-intranet">
                    <legend>Intranet</legend>
                    {hasAccessToNonReleasedCASchedule &&
                        <div className={'row' + permissionCss(Permissions.ViewCanSeeNonReleasedCASchedule, Permissions.EditCanSeeNonReleasedCASchedule)}>
                            <div className="col">
                                <Checkbox
                                    label="Can see non-released CA schedules"
                                    checked={personInfo.canViewUnreleasedCaSchedules}
                                    onChange={this._onCAChange}
                                    disabled={!hasPermission(Permissions.EditCanSeeNonReleasedCASchedule, !AzureAuth.isReadOnly)}
                                />
                            </div>
                        </div>
                    }
                    <br />
                    {hasAccessToNonReleasedCOSchedule &&
                        <div className={'row' + permissionCss(Permissions.ViewCanSeeNonReleasedCOSchedule, Permissions.EditCanSeeNonReleasedCOSchedule)}>
                            <div className="col">
                                <Checkbox
                                    label="Can see non-released CO schedules"
                                    checked={personInfo.canViewUnreleasedCoSchedules}
                                    onChange={this._onCOChange}
                                    disabled={!hasPermission(Permissions.EditCanSeeNonReleasedCOSchedule, !AzureAuth.isReadOnly)}
                                />
                            </div>
                        </div>
                    }
                    <br />
                    {hasAccessToDownloadBuddySchedules &&
                        <div className={'row' + permissionCss(Permissions.ViewCanDownloadBuddySchedules, Permissions.EditCanDownloadBuddySchedules)}>
                            <div className="col">
                                <Checkbox
                                    label="Can download buddy schedules"
                                    checked={personInfo.canDownloadBuddySchedules}
                                    onChange={this._onBuddyChange}
                                    disabled={!hasPermission(Permissions.EditCanDownloadBuddySchedules, !AzureAuth.isReadOnly)}
                                />
                            </div>
                        </div>
                    }
                    <br />
                    {hasAccessToAllSchedules &&
                        <div className={'row' + permissionCss(Permissions.ViewCanSeeAllSchedules, Permissions.EditCanSeeAllSchedules)}>
                            <div className="col">
                                <Checkbox
                                    label="Can see all Schedules"
                                    checked={personInfo.canSeeAllSchedules}
                                    onChange={this._onSeeAllSchedulesChange}
                                    disabled={!hasPermission(Permissions.EditCanSeeAllSchedules, !AzureAuth.isReadOnly)}
                                />
                            </div>
                        </div>
                    }
                </fieldset>
            </div>
        );
    }

    private _onCAChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (!securityService.hasPermission(Permissions.EditCanSeeNonReleasedCASchedule, !AzureAuth.isReadOnly)) return;
        this.props.onChangeCheckboxHandler('canViewUnreleasedCaSchedules', !!checked);
	};

	private _onCOChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (!securityService.hasPermission(Permissions.EditCanSeeNonReleasedCOSchedule, !AzureAuth.isReadOnly)) return;
        this.props.onChangeCheckboxHandler('canViewUnreleasedCoSchedules', !!checked);
	};

	private _onBuddyChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (!securityService.hasPermission(Permissions.EditCanDownloadBuddySchedules, !AzureAuth.isReadOnly)) return;
        this.props.onChangeCheckboxHandler('canDownloadBuddySchedules', !!checked);
	};

	private _onSeeAllSchedulesChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (!securityService.hasPermission(Permissions.EditCanSeeAllSchedules, !AzureAuth.isReadOnly)) return;
        this.props.onChangeCheckboxHandler('canSeeAllSchedules', !!checked);
	};
}